// --- websocket --------------------------------------------------------------
export const WsMessageType = {
    HELLO: 'hello',
    SUBSCRIBE: 'subscribe',
    TICK: 'tick',
    VILLAGE_UPDATE: 'village_update',
    BUILDING_COMPLETE: 'building_complete',
    TRAINING_COMPLETE: 'training_complete',
    MOVEMENT_UPDATE: 'movement_update',
    BATTLE_REPORT: 'battle_report',
    NOTIFICATION: 'notification',
    /** Client to server: say something. Server to client: someone said something. */
    CHAT: 'chat',
    /** Server to client, once on connect: the rolling buffer for each room. */
    CHAT_HISTORY: 'chat_history',
    ERROR: 'error',
};
//# sourceMappingURL=api.js.map